import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useEffect, useCallback, useMemo } from 'react';
import classNames from 'classnames';
import { SelectList } from '../../SelectList/SelectList.es.js';
import { useFilterGroup } from '../FilterGroup.Context/index.es.js';

/**
 * Multi Filter Dropdown Menu.
 */ const MultiFilterDropdown = ({ isOpen, dropDirection = 'down', menuDisplays, className, children })=>{
    const { setCurrentFilter } = useFilterGroup();
    const [selectedMenuItem, setSelectedMenuItem] = useState();
    useEffect(()=>{
        const item = menuDisplays[0];
        if (item != null) {
            setSelectedMenuItem({
                label: item.label,
                icon: item.icon,
                value: item
            });
        }
    }, [
        menuDisplays
    ]);
    const menuContainerCss = classNames('multi-filter-dropdown-menu-container', `drop-direction-${dropDirection}`, {
        open: isOpen
    }, className);
    const handleMenuItemSelected = useCallback((item)=>{
        setSelectedMenuItem(item);
        if (item?.value) {
            setCurrentFilter(item.value.name);
        }
    }, [
        setCurrentFilter
    ]);
    const menuItems = useMemo(()=>{
        return menuDisplays.map((item)=>({
                label: item.label,
                icon: item.icon,
                value: item
            }));
    }, [
        menuDisplays
    ]);
    return jsxs("div", {
        className: menuContainerCss,
        "data-testid": "menu-container",
        children: [
            jsx(SelectList, {
                className: "select-list-container",
                selected: selectedMenuItem,
                children: menuItems.map((item, index)=>jsx(SelectList.Item, {
                        className: "select-item-container",
                        "data-testid": `list-item-${item.label}`,
                        handleSelect: handleMenuItemSelected,
                        item: item,
                        selectedStyle: "secondary",
                        children: jsx(SelectList.Item.Icon, {
                            align: "left",
                            name: item.icon,
                            size: 24
                        })
                    }, index))
            }),
            jsx("hr", {
                className: "divider"
            }),
            jsx("div", {
                className: "filter-item-container",
                children: children
            })
        ]
    });
};

export { MultiFilterDropdown, MultiFilterDropdown as default };
//# sourceMappingURL=FilterGroup.MultiFilterDropdown.es.js.map
